<template>
	<table class="table-main history">
		<thead>
			<tr>
				<th class="history__date">변경시간</th>
				<th class="history__key">항목</th>
				<th>변경 후</th>
				<th>변경 전</th>
			</tr>
		</thead>
		<tbody v-for="(log, logIdx) in logs" :key="logIdx">
			<tr v-for="(item, idx) in log.changes" :key="item.key">
				<td
					v-if="idx === 0"
					v-html="log.createdAt"
					:rowspan="log.changes.length"
					class="history__date"
				/>
				<td class="text-left history__key">{{ item.key }}</td>
				<td
					:class="[
						'text-left',
						{
							history__category: item.key === '카테고리',
						},
					]"
				>
					<table v-if="item.key === '카테고리'">
						<thead>
							<tr>
								<th>1차</th>
								<th>2차</th>
								<th>3차</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(category, categoryIdx) in item.cur"
								:key="categoryIdx"
							>
								<td
									v-for="categoryName in category"
									:key="categoryName"
								>
									{{ categoryName }}
								</td>
							</tr>
						</tbody>
					</table>
					<pre
						v-else
						v-text="item.cur"
						class="history__content history__current"
					/>
				</td>
				<td
					:class="[
						'text-left',
						{
							history__category: item.key === '카테고리',
						},
					]"
				>
					<table v-if="item.key === '카테고리'">
						<thead>
							<tr>
								<th>1차</th>
								<th>2차</th>
								<th>3차</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(category, categoryIdx) in item.before"
								:key="categoryIdx"
							>
								<td
									v-for="categoryName in category"
									:key="categoryName"
								>
									{{ categoryName }}
								</td>
							</tr>
						</tbody>
					</table>
					<pre v-else v-text="item.before" class="history__content" />
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	import union from 'lodash/union';
	import isEqual from 'lodash/isEqual';
	import compact from 'lodash/compact';
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'ProductChangeHistory',
		data() {
			return {
				keyMap: {
					brandTypeList: '스토어',
					colorType: '컬러/타입',
					factorList: '성분 목록',
					factorsDisplay: '성분 전시 여부',
					fileOrgName: '사진 원본 파일명',
					fileSaveName: '사진 파일명',
					fileDir: '사진 저장 경로',
					fileSize: '사진 크기',
					fileType: '사진 타입',
					idBrand: '브랜드',
					idProduct: '제품 ID',
					insertIdRegister: '수정한 직원',
					isDiscontinue: '단종여부',
					isDisplay: '상태',
					price: '가격',
					productText: '제품 설명',
					productTitle: '제품명',
					volume: '용량',
					releaseYear: '발매년도',
					releaseMonth: '발매달',
					keywordList: '키워드',
					categoryMappings: '카테고리',
					primarySecondCategory: '대표 2차 카테고리',
				},
				logs: [],
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
				storeListOrigin: state =>
					state.ProductController.storeListOrigin,
				firstCategories: state => state.filter.firstCategories,
				secondCategories: state => state.filter.secondCategories,
				thirdCategories: state => state.filter.thirdCategories,
			}),
			...mapGetters({
				keywords: 'keywords',
				categoryName: 'categoryName',
			}),
		},
		created() {
			this.getLogs();
		},
		methods: {
			isEqualArr(arr1 = [], arr2 = []) {
				return isEqual(arr1.sort(), arr2.sort());
			},
			checkExceptUndefined(value, name1, name2) {
				return value === undefined ? '' : value ? name1 : name2;
			},
			async parseChanges(key, cur, before) {
				if (isEqual(cur, before)) {
					return null;
				}
				let parse = null;
				switch (key) {
					case 'brandTypeList':
						if (this.isEqualArr(cur, before)) {
							return null;
						}
						parse = value =>
							value
								? value
										.map(
											id =>
												this.storeListOrigin.find(
													item =>
														item.idBrandType === id
												).brandTypeName
										)
										.sort()
										.join(', ')
								: '';
						break;
					case 'factorList':
						if (
							isEqual(
								(cur || []).map(item => item.factorIdx).sort(),
								(before || [])
									.map(item => item.factorIdx)
									.sort()
							)
						) {
							return null;
						}
						parse = value =>
							value
								? value
										.map(
											item =>
												`${item.orderIndex + 1}: ${item.factorName}`
										)
										.join('\n')
								: '';
						break;
					case 'factorsDisplay':
						parse = value =>
							this.checkExceptUndefined(value, '전시', '미전시');
						break;
					case 'idBrand':
						parse = async value => {
							if (!value) {
								return '';
							}
							const {
								data: {
									data: [data],
								},
							} = await this.$axiosAdmin2.get(
								`/api/brands?idBrand=${value}&offset=0&limit=1`
							);
							return data.brandTitle;
						};
						break;
					case 'insertIdRegister':
						parse = async value => {
							if (!value) {
								return '';
							}
							const { data } = await this.$axiosSupport(
								`/admin/adminAccount/${value}`
							);
							return data.account.nickName;
						};
						break;
					case 'isDiscontinue':
						parse = value =>
							this.checkExceptUndefined(value, '단종', '미단종');
						break;
					case 'isDisplay':
						parse = value =>
							this.checkExceptUndefined(value, '전시', '비전시');
						break;
					case 'keywordList':
						if (this.isEqualArr(cur, before)) {
							return null;
						}
						parse = value =>
							value
								? value
										.map(
											id =>
												this.keywords.find(
													item => item.id === id
												).name
										)
										.sort()
										.join(', ')
								: '';
						break;
					case 'categoryMappings':
						parse = value =>
							value
								? value.map(item => [
										this.categoryName(
											'First',
											item.idFirstCategory
										),
										this.categoryName(
											'Second',
											item.idSecondCategory
										),
										this.categoryName(
											'Third',
											item.idThirdCategory
										),
									])
								: '';
						break;
					case 'primarySecondCategory':
						parse = value =>
							value
								? this.secondCategories.find(
										({ idSecondCategory }) =>
											idSecondCategory === value
									).secondCategoryText
								: '';
						break;
				}
				if (parse) {
					cur = await parse(cur);
					before = await parse(before);
				}
				return { key: this.keyMap[key], cur, before };
			},
			async compactLogs(logs) {
				return compact(
					await Promise.all(
						logs.map(async log => {
							const keys = union(
								Object.keys(log.doc),
								Object.keys(log.before_doc)
							);
							const list = compact(
								await Promise.all(
									keys.map(key =>
										this.parseChanges(
											key,
											log.doc[key],
											log.before_doc[key]
										)
									)
								)
							);
							return list.length ? list : null;
						})
					)
				);
			},
			async getLogs() {
				try {
					const {
						data: { admin_logs },
					} = await this.$axiosSupport.get(
						`/admin/product/${this.params.idProduct}/admin_log`
					);
					const logs = await this.compactLogs(admin_logs);
					this.logs = admin_logs.map((item, idx) => ({
						createdAt: moment(item.created_at).format(
							'YYYY-MM-DD<br>HH:mm'
						),
						changes: logs[idx],
					}));
				} catch (err) {
					console.error(err);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.history {
		margin-top: 18px;
		table-layout: fixed;

		thead {
			background-color: #f4f7fa;
		}

		tbody {
			border: solid 1px #dfe6ee;

			&:nth-child(odd) {
				background-color: #f4f7fa;
			}

			&:first-of-type .history__current {
				display: inline-block;
				background: $btn-blue;
				padding: 4px 6px;
				border-radius: 8px;
				vertical-align: middle;
				line-height: 16px;
				color: white;
			}
		}

		tr:hover {
			background-color: transparent;
		}

		.history__date {
			width: 90px;
			padding: 0;
		}

		.history__key {
			width: 120px;
			font-weight: bold;
		}

		.history__category {
			vertical-align: top;
			padding: 0;

			tbody {
				border: 0;
			}

			th,
			td {
				height: auto;
				padding: 4px;

				&:first-child {
					border-left: 0;
				}

				&:last-child {
					border-right: 0;
				}
			}

			th {
				border-top: 0;
			}

			td {
				text-align: left;
			}
		}

		.history__content {
			background: transparent;
			white-space: pre-wrap;
		}
	}
</style>
